import { createAction } from './core';
// PUBLIC API
export const addOrganizationMember = createAction('operations/add-organization-member', ['OrganizationMembership', 'User', 'Organization']);
// PUBLIC API
export const updateOrganizationMember = createAction('operations/update-organization-member', ['OrganizationMembership', 'User', 'Organization']);
// PUBLIC API
export const removeOrganizationMember = createAction('operations/remove-organization-member', ['OrganizationMembership', 'User', 'Organization']);
// PUBLIC API
export const verifySiteAccessPassword = createAction('operations/verify-site-access-password', ['GlobalSettings']);
// PUBLIC API
export const updateSiteAccessSettings = createAction('operations/update-site-access-settings', ['GlobalSettings']);
// PUBLIC API
export const updateUserPrimaryLocation = createAction('operations/update-user-primary-location', ['User', 'LocationMembership', 'Location']);
// PUBLIC API
export const updateLocationSubscription = createAction('operations/update-location-subscription', ['LocationMembership', 'UserNotificationPreference', 'User']);
// PUBLIC API
export const createLocationMembershipForUser = createAction('operations/create-location-membership-for-user', ['LocationMembership', 'Location', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteLocationMembershipForUser = createAction('operations/delete-location-membership-for-user', ['LocationMembership', 'User']);
// PUBLIC API
export const updateUserProfile = createAction('operations/update-user-profile', ['User']);
// PUBLIC API
export const updateUserByAdmin = createAction('operations/update-user-by-admin', ['User', 'LocationMembership']);
// PUBLIC API
export const adminCreateUser = createAction('operations/admin-create-user', ['User']);
// PUBLIC API
export const adminSetUserPassword = createAction('operations/admin-set-user-password', ['User']);
// PUBLIC API
export const softDeleteUser = createAction('operations/soft-delete-user', ['User']);
// PUBLIC API
export const bulkSoftDeleteUsers = createAction('operations/bulk-soft-delete-users', ['User']);
// PUBLIC API
export const restoreDeletedUser = createAction('operations/restore-deleted-user', ['User']);
// PUBLIC API
export const permanentlyDeleteUser = createAction('operations/permanently-delete-user', ['User']);
// PUBLIC API
export const approveUser = createAction('operations/approve-user', ['User']);
// PUBLIC API
export const rejectUser = createAction('operations/reject-user', ['User']);
// PUBLIC API
export const generateGptResponse = createAction('operations/generate-gpt-response', ['User', 'Task', 'GptResponse']);
// PUBLIC API
export const createTask = createAction('operations/create-task', ['Task']);
// PUBLIC API
export const deleteTask = createAction('operations/delete-task', ['Task']);
// PUBLIC API
export const updateTask = createAction('operations/update-task', ['Task']);
// PUBLIC API
export const generateCheckoutSession = createAction('operations/generate-checkout-session', ['User']);
// PUBLIC API
export const createFile = createAction('operations/create-file', ['User', 'File']);
// PUBLIC API
export const createOrganizationType = createAction('operations/create-organization-type', ['OrganizationType']);
// PUBLIC API
export const updateOrganizationType = createAction('operations/update-organization-type', ['OrganizationType']);
// PUBLIC API
export const deleteOrganizationType = createAction('operations/delete-organization-type', ['OrganizationType']);
// PUBLIC API
export const linkSectionToOrganizationType = createAction('operations/link-section-to-organization-type', ['OrgTypeSection', 'Section']);
// PUBLIC API
export const unlinkSectionFromOrganizationType = createAction('operations/unlink-section-from-organization-type', ['OrgTypeSection']);
// PUBLIC API
export const updateOrgTypeSection = createAction('operations/update-org-type-section', ['OrgTypeSection']);
// PUBLIC API
export const linkServiceTypeToOrganizationType = createAction('operations/link-service-type-to-organization-type', ['OrgTypeServiceType', 'ServiceDefinition']);
// PUBLIC API
export const unlinkServiceTypeFromOrganizationType = createAction('operations/unlink-service-type-from-organization-type', ['OrgTypeServiceType']);
// PUBLIC API
export const updateOrgTypeServiceType = createAction('operations/update-org-type-service-type', ['OrgTypeServiceType']);
// PUBLIC API
export const linkTopicTypeToOrganizationType = createAction('operations/link-topic-type-to-organization-type', ['OrgTypeTopicType', 'Topic']);
// PUBLIC API
export const unlinkTopicTypeFromOrganizationType = createAction('operations/unlink-topic-type-from-organization-type', ['OrgTypeTopicType']);
// PUBLIC API
export const updateOrgTypeTopicType = createAction('operations/update-org-type-topic-type', ['OrgTypeTopicType']);
// PUBLIC API
export const createLocationType = createAction('operations/create-location-type', ['LocationType']);
// PUBLIC API
export const updateLocationType = createAction('operations/update-location-type', ['LocationType']);
// PUBLIC API
export const deleteLocationType = createAction('operations/delete-location-type', ['LocationType']);
// PUBLIC API
export const linkServiceTypeToLocationType = createAction('operations/link-service-type-to-location-type', ['LocTypeServiceType', 'ServiceDefinition']);
// PUBLIC API
export const unlinkServiceTypeFromLocationType = createAction('operations/unlink-service-type-from-location-type', ['LocTypeServiceType']);
// PUBLIC API
export const updateLocTypeServiceType = createAction('operations/update-loc-type-service-type', ['LocTypeServiceType']);
// PUBLIC API
export const linkTopicTypeToLocationType = createAction('operations/link-topic-type-to-location-type', ['LocTypeTopicType', 'Topic']);
// PUBLIC API
export const unlinkTopicTypeFromLocationType = createAction('operations/unlink-topic-type-from-location-type', ['LocTypeTopicType']);
// PUBLIC API
export const updateLocTypeTopicType = createAction('operations/update-loc-type-topic-type', ['LocTypeTopicType']);
// PUBLIC API
export const createSection = createAction('operations/create-section', ['Section']);
// PUBLIC API
export const updateSection = createAction('operations/update-section', ['Section']);
// PUBLIC API
export const deleteSection = createAction('operations/delete-section', ['Section']);
// PUBLIC API
export const createOccasionType = createAction('operations/create-occasion-type', ['OccasionType']);
// PUBLIC API
export const updateOccasionType = createAction('operations/update-occasion-type', ['OccasionType']);
// PUBLIC API
export const deleteOccasionType = createAction('operations/delete-occasion-type', ['OccasionType']);
// PUBLIC API
export const createOrganization = createAction('operations/create-organization', ['Organization']);
// PUBLIC API
export const updateOrganization = createAction('operations/update-organization', ['Organization']);
// PUBLIC API
export const deleteOrganization = createAction('operations/delete-organization', ['Organization', 'LocationOrganization']);
// PUBLIC API
export const linkOrganizationToLocation = createAction('operations/link-organization-to-location', ['LocationOrganization', 'Organization']);
// PUBLIC API
export const unlinkOrganizationFromLocation = createAction('operations/unlink-organization-from-location', ['LocationOrganization', 'Organization']);
// PUBLIC API
export const setPrimaryOrganization = createAction('operations/set-primary-organization', ['LocationOrganization']);
// PUBLIC API
export const createFieldConfig = createAction('operations/create-field-config', ['FieldConfig']);
// PUBLIC API
export const updateFieldConfig = createAction('operations/update-field-config', ['FieldConfig']);
// PUBLIC API
export const deleteFieldConfig = createAction('operations/delete-field-config', ['FieldConfig']);
// PUBLIC API
export const reorderFieldConfigs = createAction('operations/reorder-field-configs', ['FieldConfig']);
// PUBLIC API
export const createGlobalSetting = createAction('operations/create-global-setting', ['GlobalSettings']);
// PUBLIC API
export const updateGlobalSetting = createAction('operations/update-global-setting', ['GlobalSettings']);
// PUBLIC API
export const createSectionVisibility = createAction('operations/create-section-visibility', ['SectionVisibility']);
// PUBLIC API
export const updateSectionVisibility = createAction('operations/update-section-visibility', ['SectionVisibility']);
// PUBLIC API
export const toggleMaintenanceMode = createAction('operations/toggle-maintenance-mode', ['GlobalSettings']);
// PUBLIC API
export const toggleBulkUpload = createAction('operations/toggle-bulk-upload', ['GlobalSettings']);
// PUBLIC API
export const toggleRegistration = createAction('operations/toggle-registration', ['GlobalSettings']);
// PUBLIC API
export const toggleSignupApproval = createAction('operations/toggle-signup-approval', ['GlobalSettings']);
// PUBLIC API
export const toggleCommunitySection = createAction('operations/toggle-community-section', ['GlobalSettings']);
// PUBLIC API
export const toggleOrganizationsSection = createAction('operations/toggle-organizations-section', ['GlobalSettings']);
// PUBLIC API
export const toggleBuySellFormMode = createAction('operations/toggle-buy-sell-form-mode', ['GlobalSettings']);
// PUBLIC API
export const toggleSimplifiedFormEnabled = createAction('operations/toggle-simplified-form-enabled', ['GlobalSettings']);
// PUBLIC API
export const updatePlatformTheme = createAction('operations/update-platform-theme', ['GlobalSettings']);
// PUBLIC API
export const updateUserPlatformRole = createAction('operations/update-user-platform-role', ['User']);
// PUBLIC API
export const assignModeratorRole = createAction('operations/assign-moderator-role', ['User']);
// PUBLIC API
export const revokeModeratorRole = createAction('operations/revoke-moderator-role', ['User']);
// PUBLIC API
export const bulkLinkOrganizationsToLocation = createAction('operations/bulk-link-organizations-to-location', ['LocationOrganization', 'Organization']);
// PUBLIC API
export const toggleLocationSubscription = createAction('operations/toggle-location-subscription', ['LocationMembership', 'Location', 'UserNotificationPreference', 'User']);
// PUBLIC API
export const toggleLocationNavVisibility = createAction('operations/toggle-location-nav-visibility', ['LocationMembership', 'Location', 'User']);
// PUBLIC API
export const toggleOrganizationSubscription = createAction('operations/toggle-organization-subscription', ['OrganizationMembership', 'Organization']);
// PUBLIC API
export const bulkCreateLocationTypes = createAction('operations/bulk-create-location-types', ['LocationType']);
// PUBLIC API
export const bulkCreateOrganizationTypes = createAction('operations/bulk-create-organization-types', ['OrganizationType']);
// PUBLIC API
export const bulkCreateTopicTypes = createAction('operations/bulk-create-topic-types', ['TopicType']);
// PUBLIC API
export const bulkCreateLocations = createAction('operations/bulk-create-locations', ['Location', 'LocationType']);
// PUBLIC API
export const bulkCreateOrganizations = createAction('operations/bulk-create-organizations', ['Organization', 'OrganizationType']);
// PUBLIC API
export const bulkCreateUsers = createAction('operations/bulk-create-users', ['User', 'Location']);
// PUBLIC API
export const bulkCreateSections = createAction('operations/bulk-create-sections', ['Section', 'SectionTranslation']);
// PUBLIC API
export const bulkCreateServiceDefinitions = createAction('operations/bulk-create-service-definitions', ['ServiceDefinition', 'ServiceType']);
// PUBLIC API
export const bulkCreateTopics = createAction('operations/bulk-create-topics', ['Topic', 'TopicType']);
// PUBLIC API
export const universalBulkImport = createAction('operations/universal-bulk-import', ['LocationType', 'OrganizationType', 'TopicType', 'ServiceType', 'Location', 'Organization', 'Topic', 'Section', 'SectionTranslation', 'ServiceDefinition', 'User', 'BulkImportHistory']);
// PUBLIC API
export const subscribeToLocation = createAction('operations/subscribe-to-location', ['LocationMembership', 'Location', 'UserNotificationPreference', 'User']);
// PUBLIC API
export const verifyWithCode = createAction('operations/verify-with-code', ['LocationMembership', 'InviteCode', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const generateInviteCode = createAction('operations/generate-invite-code', ['InviteCode', 'LocationMembership']);
// PUBLIC API
export const createLocation = createAction('operations/create-location', ['Location', 'LocationMembership']);
// PUBLIC API
export const updateLocation = createAction('operations/update-location', ['Location', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const updateLocationContentApprovalSettings = createAction('operations/update-location-content-approval-settings', ['Location', 'LocationMembership']);
// PUBLIC API
export const setMemberPostWithoutApproval = createAction('operations/set-member-post-without-approval', ['LocationMembership', 'Location']);
// PUBLIC API
export const deleteLocation = createAction('operations/delete-location', ['Location', 'LocationMembership', 'Content', 'Event', 'InviteCode']);
// PUBLIC API
export const setLocationParent = createAction('operations/set-location-parent', ['Location']);
// PUBLIC API
export const bulkDeleteLocationMembers = createAction('operations/bulk-delete-location-members', ['LocationMembership']);
// PUBLIC API
export const bulkDeleteLocationContent = createAction('operations/bulk-delete-location-content', ['Content']);
// PUBLIC API
export const bulkDeleteLocationEvents = createAction('operations/bulk-delete-location-events', ['Event']);
// PUBLIC API
export const moveLocationMembers = createAction('operations/move-location-members', ['LocationMembership', 'Location']);
// PUBLIC API
export const moveLocationContent = createAction('operations/move-location-content', ['Content', 'Location']);
// PUBLIC API
export const moveLocationEvents = createAction('operations/move-location-events', ['Event', 'Location']);
// PUBLIC API
export const createContent = createAction('operations/create-content', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const updateContent = createAction('operations/update-content', ['Content', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const deleteContent = createAction('operations/delete-content', ['Content', 'LocationMembership']);
// PUBLIC API
export const createEvent = createAction('operations/create-event', ['Event', 'Location', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const updateEvent = createAction('operations/update-event', ['Event', 'Location', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteEvent = createAction('operations/delete-event', ['Event', 'LocationMembership', 'User']);
// PUBLIC API
export const rsvpToEvent = createAction('operations/rsvp-to-event', ['EventAttendee', 'Event', 'LocationMembership']);
// PUBLIC API
export const syncInvestOttawaEvents = createAction('operations/sync-invest-ottawa-events', ['Event', 'Location', 'User', 'GlobalSettings']);
// PUBLIC API
export const createTenant = createAction('operations/create-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const updateTenant = createAction('operations/update-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const deleteTenant = createAction('operations/delete-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const createNotice = createAction('operations/create-notice', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const updateNotice = createAction('operations/update-notice', ['Content', 'Location', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const deleteNotice = createAction('operations/delete-notice', ['Content', 'LocationMembership', 'LocationPermission', 'User']);
// PUBLIC API
export const approveNotice = createAction('operations/approve-notice', ['Content', 'Location', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const pinNotice = createAction('operations/pin-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const archiveNotice = createAction('operations/archive-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const createFacility = createAction('operations/create-facility', ['Content', 'Location', 'LocationMembership', 'User', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const updateFacility = createAction('operations/update-facility', ['Content', 'Location', 'LocationMembership', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const deleteFacility = createAction('operations/delete-facility', ['Content', 'LocationMembership', 'LocationPermission', 'User']);
// PUBLIC API
export const createBuySell = createAction('operations/create-buy-sell', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateBuySell = createAction('operations/update-buy-sell', ['Content', 'Location', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const deleteBuySell = createAction('operations/delete-buy-sell', ['Content', 'User']);
// PUBLIC API
export const createRequestOffer = createAction('operations/create-request-offer', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateRequestOffer = createAction('operations/update-request-offer', ['Content', 'Location', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteRequestOffer = createAction('operations/delete-request-offer', ['Content', 'User']);
// PUBLIC API
export const createTransportation = createAction('operations/create-transportation', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateTransportation = createAction('operations/update-transportation', ['Content', 'Location', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteTransportation = createAction('operations/delete-transportation', ['Content', 'User']);
// PUBLIC API
export const createFoodCourtItem = createAction('operations/create-food-court-item', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateFoodCourtItem = createAction('operations/update-food-court-item', ['Content', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference', 'PushSubscription']);
// PUBLIC API
export const deleteFoodCourtItem = createAction('operations/delete-food-court-item', ['Content', 'User']);
// PUBLIC API
export const createFoodCourtMenuUpload = createAction('operations/create-food-court-menu-upload', ['User']);
// PUBLIC API
export const uploadFoodCourtMenuLocal = createAction('operations/upload-food-court-menu-local', ['Content', 'User']);
// PUBLIC API
export const createLostFound = createAction('operations/create-lost-found', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateLostFound = createAction('operations/update-lost-found', ['Content', 'Location', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteLostFound = createAction('operations/delete-lost-found', ['Content', 'User']);
// PUBLIC API
export const createService = createAction('operations/create-service', ['Content', 'Location', 'User', 'ApprovalRequest', 'LocationMembership', 'LocationPermission', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference']);
// PUBLIC API
export const updateService = createAction('operations/update-service', ['Content', 'Location', 'Notification', 'NotificationPendingFlush', 'User', 'UserNotificationPreference']);
// PUBLIC API
export const deleteService = createAction('operations/delete-service', ['Content', 'User']);
// PUBLIC API
export const grantPermissions = createAction('operations/grant-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const revokePermissions = createAction('operations/revoke-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const approvePost = createAction('operations/approve-post', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference', 'PushSubscription', 'LocationMembership']);
// PUBLIC API
export const rejectPost = createAction('operations/reject-post', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'ContentRecycleBin']);
// PUBLIC API
export const checkPermission = createAction('operations/check-permission', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const submitForApproval = createAction('operations/submit-for-approval', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'LocationPermission', 'LocationMembership', 'Organization', 'OrganizationMembership']);
// PUBLIC API
export const approveContent = createAction('operations/approve-content', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'NotificationPendingFlush', 'UserNotificationPreference', 'PushSubscription', 'LocationPermission', 'LocationMembership', 'Organization', 'OrganizationMembership']);
// PUBLIC API
export const rejectContent = createAction('operations/reject-content', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'ContentRecycleBin', 'LocationPermission', 'LocationMembership', 'Organization', 'OrganizationMembership']);
// PUBLIC API
export const cancelApprovalRequest = createAction('operations/cancel-approval-request', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const markNotificationRead = createAction('operations/mark-notification-read', ['Notification', 'User']);
// PUBLIC API
export const markAllNotificationsRead = createAction('operations/mark-all-notifications-read', ['Notification', 'User']);
// PUBLIC API
export const deleteNotification = createAction('operations/delete-notification', ['Notification', 'User']);
// PUBLIC API
export const createNotification = createAction('operations/create-notification', ['Notification', 'User', 'Location']);
// PUBLIC API
export const updateNotificationPreferences = createAction('operations/update-notification-preferences', ['User', 'UserNotificationPreference', 'LocationMembership', 'Location']);
// PUBLIC API
export const restoreFromRecycleBin = createAction('operations/restore-from-recycle-bin', ['ContentRecycleBin', 'Content', 'User', 'Location']);
// PUBLIC API
export const extendDeletionDate = createAction('operations/extend-deletion-date', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const cleanupExpiredEntries = createAction('operations/cleanup-expired-entries', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const createOccasion = createAction('operations/create-occasion', ['Occasion', 'OccasionType', 'User']);
// PUBLIC API
export const updateOccasion = createAction('operations/update-occasion', ['Occasion', 'OccasionType', 'User']);
// PUBLIC API
export const deleteOccasion = createAction('operations/delete-occasion', ['Occasion', 'OccasionType', 'User']);
// PUBLIC API
export const activateOccasionForLocation = createAction('operations/activate-occasion-for-location', ['LocationOccasion', 'Location', 'Occasion', 'User', 'LocationMembership']);
// PUBLIC API
export const deactivateOccasionForLocation = createAction('operations/deactivate-occasion-for-location', ['LocationOccasion', 'Location', 'Occasion', 'User', 'LocationMembership']);
// PUBLIC API
export const createTopicType = createAction('operations/create-topic-type', ['TopicType']);
// PUBLIC API
export const updateTopicType = createAction('operations/update-topic-type', ['TopicType']);
// PUBLIC API
export const deleteTopicType = createAction('operations/delete-topic-type', ['TopicType']);
// PUBLIC API
export const createTopic = createAction('operations/create-topic', ['Topic', 'TopicType', 'User']);
// PUBLIC API
export const updateTopic = createAction('operations/update-topic', ['Topic', 'TopicType', 'User']);
// PUBLIC API
export const deleteTopic = createAction('operations/delete-topic', ['Topic', 'TopicType', 'User']);
// PUBLIC API
export const linkTopicToService = createAction('operations/link-topic-to-service', ['TopicService', 'Topic', 'Content', 'User']);
// PUBLIC API
export const unlinkTopicFromService = createAction('operations/unlink-topic-from-service', ['TopicService', 'Topic', 'Content', 'User']);
// PUBLIC API
export const linkTopicToOccasion = createAction('operations/link-topic-to-occasion', ['TopicOccasion', 'Topic', 'Occasion', 'User']);
// PUBLIC API
export const unlinkTopicFromOccasion = createAction('operations/unlink-topic-from-occasion', ['TopicOccasion', 'Topic', 'Occasion', 'User']);
// PUBLIC API
export const createServiceType = createAction('operations/create-service-type', ['ServiceType']);
// PUBLIC API
export const updateServiceType = createAction('operations/update-service-type', ['ServiceType']);
// PUBLIC API
export const deleteServiceType = createAction('operations/delete-service-type', ['ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const createServiceDefinition = createAction('operations/create-service-definition', ['ServiceDefinition', 'ServiceType']);
// PUBLIC API
export const updateServiceDefinition = createAction('operations/update-service-definition', ['ServiceDefinition', 'ServiceType']);
// PUBLIC API
export const deleteServiceDefinition = createAction('operations/delete-service-definition', ['ServiceDefinition', 'ServiceOffering']);
// PUBLIC API
export const createServiceOffering = createAction('operations/create-service-offering', ['ServiceOffering', 'ServiceDefinition', 'Location', 'Organization', 'LocationMembership', 'OrganizationMembership', 'User']);
// PUBLIC API
export const updateServiceOffering = createAction('operations/update-service-offering', ['ServiceOffering', 'LocationMembership', 'OrganizationMembership', 'User']);
// PUBLIC API
export const deleteServiceOffering = createAction('operations/delete-service-offering', ['ServiceOffering', 'LocationMembership', 'OrganizationMembership', 'User']);
// PUBLIC API
export const activateServiceOffering = createAction('operations/activate-service-offering', ['ServiceOffering', 'LocationMembership', 'OrganizationMembership', 'User']);
// PUBLIC API
export const duplicateServiceOffering = createAction('operations/duplicate-service-offering', ['ServiceOffering', 'ServiceDefinition', 'LocationMembership', 'OrganizationMembership', 'User']);
// PUBLIC API
export const linkDefinitionToTopic = createAction('operations/link-definition-to-topic', ['TopicServiceDefinition', 'ServiceDefinition', 'Topic']);
// PUBLIC API
export const unlinkDefinitionFromTopic = createAction('operations/unlink-definition-from-topic', ['TopicServiceDefinition']);
// PUBLIC API
export const linkDefinitionToOccasion = createAction('operations/link-definition-to-occasion', ['OccasionServiceDefinition', 'ServiceDefinition', 'Occasion']);
// PUBLIC API
export const unlinkDefinitionFromOccasion = createAction('operations/unlink-definition-from-occasion', ['OccasionServiceDefinition']);
// PUBLIC API
export const updateCanadaProvince = createAction('operations/update-canada-province', ['CanadaProvince']);
// PUBLIC API
export const createCanadaMunicipality = createAction('operations/create-canada-municipality', ['CanadaMunicipality']);
// PUBLIC API
export const updateCanadaMunicipality = createAction('operations/update-canada-municipality', ['CanadaMunicipality']);
// PUBLIC API
export const deleteCanadaMunicipality = createAction('operations/delete-canada-municipality', ['CanadaMunicipality']);
// PUBLIC API
export const seedCanadaProvinces = createAction('operations/seed-canada-provinces', ['CanadaProvince']);
// PUBLIC API
export const createCanadaNeighbourhood = createAction('operations/create-canada-neighbourhood', ['CanadaNeighbourhood', 'CanadaNeighbourhoodFsa']);
// PUBLIC API
export const updateCanadaNeighbourhood = createAction('operations/update-canada-neighbourhood', ['CanadaNeighbourhood']);
// PUBLIC API
export const deleteCanadaNeighbourhood = createAction('operations/delete-canada-neighbourhood', ['CanadaNeighbourhood']);
// PUBLIC API
export const createCanadaSuburb = createAction('operations/create-canada-suburb', ['CanadaSuburb']);
// PUBLIC API
export const updateCanadaSuburb = createAction('operations/update-canada-suburb', ['CanadaSuburb']);
// PUBLIC API
export const deleteCanadaSuburb = createAction('operations/delete-canada-suburb', ['CanadaSuburb']);
// PUBLIC API
export const addNeighbourhoodFsa = createAction('operations/add-neighbourhood-fsa', ['CanadaNeighbourhoodFsa']);
// PUBLIC API
export const removeNeighbourhoodFsa = createAction('operations/remove-neighbourhood-fsa', ['CanadaNeighbourhoodFsa']);
// PUBLIC API
export const upsertOrgSectionContent = createAction('operations/upsert-org-section-content', ['OrgSectionContent', 'Organization']);
// PUBLIC API
export const updateOrgSectionStatus = createAction('operations/update-org-section-status', ['LocationSection', 'Section', 'Organization']);
// PUBLIC API
export const submitUserReport = createAction('operations/submit-user-report', ['UserReport']);
// PUBLIC API
export const resolveUserReport = createAction('operations/resolve-user-report', ['UserReport']);
// PUBLIC API
export const createTeamMember = createAction('operations/create-team-member', ['TeamMember', 'LocationMembership']);
// PUBLIC API
export const updateTeamMember = createAction('operations/update-team-member', ['TeamMember', 'LocationMembership']);
// PUBLIC API
export const deleteTeamMember = createAction('operations/delete-team-member', ['TeamMember', 'LocationMembership']);
// PUBLIC API
export const upsertInfoSection = createAction('operations/upsert-info-section', ['InfoSection', 'LocationMembership']);
// PUBLIC API
export const deleteInfoSection = createAction('operations/delete-info-section', ['InfoSection', 'LocationMembership']);
//# sourceMappingURL=index.js.map